import React, { Component,Fragment } from 'react';

class FreeReducedStudentsList extends Component {    
    render(){
        return(Object.keys(this.props.selectedStudentsObj).length>0 && <div style={{maxHeight:'100px',overflowY:'scroll',padding:'5px', marginBottom:'5px', border:'solid 1px rgb(234, 112, 102)', borderRadius:'3px' }}>
        {
            Object.keys(this.props.selectedStudentsObj).map(item=>{
                return <span style={{marginRight:'5px',marginBottom:'5px'}} className="label label-outline-success">{this.props.selectedStudentsObj[item].name}</span>
            })
        }
        </div>)
    }
}
export default FreeReducedStudentsList



// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/SetUpSchool/freeReducedStudetsList.jsx